import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "What is JetDog?",
    a: "JetDog ($JETDOG) is a community-driven meme token launched on Solana via Pump.fun. The mascot: a golden retriever in a life vest ripping across the ocean on a jetski. It's a pure meme — no roadmap promises about returns, no team-allocated cliff, just vibes and a wave.",
  },
  {
    q: "What network is JetDog on?",
    a: "Solana. The contract address is 8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump. Always copy it from this page or our official socials to avoid scam tokens.",
  },
  {
    q: "Where can I buy $JETDOG?",
    a: "Right now: Pump.fun and any Solana DEX aggregator (Jupiter, Raydium) once it migrates. You need a Solana wallet like Phantom and some SOL.",
  },
  {
    q: "Is the liquidity safe?",
    a: "Liquidity is burned at launch and contract ownership is renounced. That means no one — including the original deployer — can rugpull the pool.",
  },
  {
    q: "Is there a tax?",
    a: "Zero buy tax, zero sell tax. Trade freely without losing chunks to fees beyond standard Solana network costs.",
  },
  {
    q: "Is this financial advice?",
    a: "No. JetDog is a meme. Memecoins are extremely volatile and can go to zero. Only spend what you’re prepared to lose, and always do your own research before buying anything.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="section bg-[#07070E]" data-testid="faq-section">
      <div className="mx-auto max-w-3xl">
        <div className="text-left md:text-center">
          <p className="font-accent text-2xl text-[var(--jd-primary)]">paws up, questions answered</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl uppercase mt-2 neon-title" data-testid="faq-title">
            FAQ
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="gg-panel rounded-xl px-5 border-b-0"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger
                className="font-display text-base md:text-lg uppercase text-left hover:no-underline hover:text-[var(--jd-primary)]"
                data-testid={`faq-trigger-${i + 1}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-[var(--jd-ocean)]" data-testid={`faq-content-${i + 1}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
